<template>
  <div>
    <Filtro
      :vistoria="false"
      @filtro="makeFiltro"
      :filtroDivisao="filtroDivisao"
      :filtroRegional="filtroRegional"
      :financeiro="financeiro"
    ></Filtro>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4 mb-base">
        <vs-card>
          <vs-list>
            <vs-list-header
              icon-pack="feather"
              icon="icon-bar-chart-2"
              title="Vendas"
            ></vs-list-header>
            <vs-list-item
              icon-pack="feather"
              icon="icon-users"
              title="Vendas por Consultor"
              v-if="$can('Vendas por Consultor', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Consultor', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button>
            </vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-briefcase"
              title="Vendas por Regional"
              v-if="$can('Vendas por Regional', subjectPermission)"
              ><vs-button
                @click="selecionaGrafico('Regional', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button
            ></vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-map"
              title="Vendas por Divisão"
              v-if="$can('Vendas por Divisão', subjectPermission)"
              ><vs-button
                @click="selecionaGrafico('Divisão', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button
            ></vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-award"
              title="Vendas por Tipo"
              v-if="$can('Vendas por Tipo', subjectPermission)"
              ><vs-button
                @click="selecionaGrafico('Tipo', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button
            ></vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-server"
              title="Vendas por Grupo"
              v-if="$can('Vendas por Grupo', subjectPermission)"
              ><vs-button
                @click="selecionaGrafico('Grupo', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button
            ></vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-gift"
              title="Vendas por Produtos"
              v-if="$can('Vendas por Produtos', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Vendas por Produtos', 4)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button>
            </vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-dollar-sign"
              title="Financeiro de Vendas"
              v-if="$can('Financeiro de Vendas', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Financeiro de Vendas', 4)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button>
            </vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-clock"
              title="Tempo Médio de Conversão"
              v-if="$can('Tempo Médio de Conversão', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('TempoMedio', 2)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button>
            </vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-disc"
              title="Taxa de Conversão"
              v-if="$can('Taxa de Conversão', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Taxa de Conversão', 3)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button>
            </vs-list-item>
            <vs-list-header
              icon-pack="feather"
              icon="icon-pie-chart"
              title="Cotações"
              color="success"
            ></vs-list-header>
            <vs-list-item
              icon-pack="feather"
              icon="icon-database"
              title="Cotações por Status"
              v-if="$can('Cotações por Status', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Status', 1)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button
            ></vs-list-item>
            <vs-list-item
              icon-pack="feather"
              icon="icon-dollar-sign"
              title="Ticket Médio"
              v-if="$can('Ticket Médio', subjectPermission)"
            >
              <vs-button
                @click="selecionaGrafico('Ticket Médio', 4)"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-search"
                :disabled="carteiraCompletaOuRegional"
              ></vs-button
            ></vs-list-item>
          </vs-list>
        </vs-card>
      </div>
      <div class="vx-col w-full md:w-3/4 mb-base flex">
        <vs-card style="height: 100%">
          <div v-if="tipoGrafico" style="height: 100%">
            <h4>
              {{ tipoGrafico }} {{ formataData2(this.objSend.dataInicial) }} -
              {{ formataData2(this.objSend.dataFinal) }}
            </h4>
            <vue-apex-charts
              v-if="carregado == true && estiloGrafico == 1"
              type="bar"
              height="650"
              :options="analyticsData.salesBar.chartOptions"
              :series="analyticsData.salesBar.series"
            ></vue-apex-charts>
            <div v-if="carregado == true && estiloGrafico == 4">
              <vue-apex-charts
                type="bar"
                height="650"
                :options="analyticsData.salesBar2.chartOptions"
                :series="analyticsData.salesBar2.series"
              >
              </vue-apex-charts>
            </div>

            <div
              v-if="carregado == true && estiloGrafico == 2"
              class="vx-row mt-4"
            >
              <div
                id="divCotacoesGeradas"
                class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base"
              >
                <statistics-card-line
                  icon="ClockIcon"
                  icon-right
                  :statistic="`${dadosResult.tempoMedio[0]}h`"
                  statisticTitle="Tempo Médio até Aceite"
                  :chartData="analyticsData.activeUsers"
                  color="success"
                ></statistics-card-line>
              </div>
              <div
                id="divVistoriasRealizadas"
                class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base"
              >
                <statistics-card-line
                  icon="ClockIcon"
                  icon-right
                  :statistic="`${dadosResult.tempoMedio[1]}h`"
                  statisticTitle="Tempo Médio até Vistoria"
                  :chartData="analyticsData.siteTraffic"
                ></statistics-card-line>
              </div>
              <div
                id="divCotacoesRecusadas"
                class="vs-con-loading__container vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base"
              >
                <statistics-card-line
                  icon="ClockIcon"
                  icon-right
                  :statistic="`${dadosResult.tempoMedio[2]}h`"
                  statisticTitle="Tempo Médio até Sincronismo"
                  :chartData="analyticsData.newsletter"
                  color="warning"
                ></statistics-card-line>
              </div>
            </div>
            <div
              v-if="carregado == true && estiloGrafico == 3"
              id="divConversaoMensal"
              class="vs-con-loading__container vx-col w-full lg:w-1/1 mb-base"
            >
              <vx-card>
                <template slot="actions">
                  <feather-icon
                    icon="HelpCircleIcon"
                    svgClasses="w-6 h-6 text-grey"
                  ></feather-icon>
                </template>

                <!-- CHART -->
                <template slot="no-body">
                  <div class="mt-10">
                    <vue-apex-charts
                      type="radialBar"
                      height="240"
                      :options="
                        analyticsData.goalOverviewRadialBar.chartOptions
                      "
                      :series="dadosResult.taxaConversao.taxa"
                    />
                  </div>
                </template>

                <!-- DATA -->
                <div
                  class="flex justify-between text-center"
                  slot="no-body-bottom"
                >
                  <div
                    class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
                  >
                    <p class="mt-4">Convertidas</p>
                    <p class="mb-4 text-3xl font-semibold">
                      {{ dadosResult.taxaConversao.convertidas }}
                    </p>
                  </div>
                  <div
                    class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
                  >
                    <p class="mt-4">Total</p>
                    <p class="mb-4 text-3xl font-semibold">
                      {{ dadosResult.taxaConversao.total }}
                    </p>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <div v-else class="text-center">
            <img
              src="../../../assets/images/pages/graphic-3.png"
              alt="graphic-404"
              class="mx-auto mb-4 max-w-full"
            />
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
              KPIs e Businness Intelligence
            </h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16">
              Veja os indicadores de desempenho e os números para analise de
              Dados.
            </p>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16">
              Selecione o periodo, e os demais filtros, depois selecione o tipo
              de relatório no box ao lado.
            </p>
          </div>
        </vs-card>
      </div>
    </div>
    <vs-popup
      class="holamundo"
      title="Tela Cheia"
      :active.sync="openModal"
      :fullscreen="isFullscreen"
    >
      <div v-if="series">
        <vue-apex-charts
          type="bar"
          height="650"
          :options="options"
          :series="series"
          :key="grafico"
        >
        </vue-apex-charts>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import Filtro from './../../filtros/FiltroGraficoCrescimento';
import analyticsData from './../../../ui-elements/card/analyticsData.js';
import service from './../../../services';
import moment from 'moment';
import ability from '../../../services/ability';

export default {
  name: 'VendasRelatorio',
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      tipoGrafico: null,
      objSend: {},
      analyticsData: analyticsData,
      estiloGrafico: null,
      financeiro: false,
      openModal: false,
      isFullscreen: true,
      options: null,
      series: null,
      grafico: 0,
      carregado: false,
      filtroDivisao: false,
      filtroRegional: false,
      legenda: [],
      dadosResult: {
        tempoMedio: [0, 0, 0],
        taxaConversao: {
          taxa: [0],
          total: 0,
          convertidas: 0,
        },
      },
      subjectPermission: 'Vendas',
      carteiraCompletaOuRegional: true,
    };
  },
  methods: {
    selecionaGrafico(tipoGrafico, estiloGrafico) {
      this.options = null;
      this.series = null;
      this.grafico = this.grafico + 1;
      this.tipoGrafico = tipoGrafico;
      this.estiloGrafico = estiloGrafico;

      if (this.tipoGrafico == 'Regional') {
        this.filtroDivisao = true;
      } else {
        this.filtroDivisao = false;
      }

      if (this.tipoGrafico == 'Consultor') {
        this.filtroRegional = true;
      } else {
        this.filtroRegional = false;
      }

      if (
        this.tipoGrafico == 'Ticket Médio' ||
        this.tipoGrafico == 'Financeiro de Vendas'
      ) {
        this.financeiro = true;
      } else {
        this.financeiro = false;
      }

      this.filtraGeral();
    },
    telaCheia() {
      this.openModal = true;
    },
    preparaFiltro() {
      this.objSend = {};

      if (this.filtro) {
        this.objSend = { ...this.filtro };

        this.objSend.dataInicial = moment(this.filtro.dataInicial)
          .utc()
          .format('YYYY-MM-DD');

        this.objSend.dataFinal = moment(this.filtro.dataFinal)
          .utc()
          .format('YYYY-MM-DD');
      } else {
        this.objSend.dataInicial = moment()
          .startOf('month')
          .format('YYYY-MM-DD');

        this.objSend.dataFinal = moment().endOf('month').format('YYYY-MM-DD');
      }

      this.objSend.tipo = this.tipoGrafico;
    },
    formataData2(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
      this.filtraGeral();
    },
    filtraGeral() {
      this.preparaFiltro();
      this.buscaDados();
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
    buscaDados() {
      this.buscaDadosVendasFiltro();
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosVendasFiltro() {
      this.carregado = false;
      this.$vs.loading();
      var objSend = { ...this.objSend };

      service
        .post('Relatorios', 'relatorioVendas', objSend)
        .then((res) => {
          this.grafico = this.grafico + 1;

          if (this.estiloGrafico == 1) {
            var arrList = [];
            var arrQtd = [];
            res.data.forEach((element) => {
              arrList.push(element.lista);
              arrQtd.push(element.qtd);
            });

            const _arrList = arrList.filter((item) => Boolean(item) == true);
            analyticsData.salesBar.chartOptions.xaxis.categories = _arrList;

            const _arrQtd = arrQtd.filter((item) => Boolean(item) == true);
            analyticsData.salesBar.series[0].data = _arrQtd;

            this.options = null;
            this.series = null;

            this.options = analyticsData.salesBar.chartOptions;
            this.series = analyticsData.salesBar.series[0];

            analyticsData.salesBar.chartOptions.chart.toolbar.tools.customIcons =
              [
                {
                  icon: '<img style="opacity: 55% !important; margin: 3px 5px" src="https://cdn-icons-png.flaticon.com/512/32/32763.png?w=740&t=st=1678295581~exp=1678296181~hmac=d347c5542ab822b08e3403edde6e36e8b6ec73d6aecca54bdc1188cf98ba9b94" width="16" opacity="55">',
                  index: 0,
                  title: 'Tela Cheia',
                  class: 'custom-icon',
                  click: this.telaCheia,
                },
              ];
          }

          if (this.estiloGrafico == 2) {
            if (this.tipoGrafico == 'TempoMedio') {
              var arr = [
                res.data[0].tempoMedioAceite ? res.data[0].tempoMedioAceite : 0,
                res.data[0].tempoMedioVistoria
                  ? res.data[0].tempoMedioVistoria
                  : 0,
                res.data[0].tempoMedioSincronizacao
                  ? res.data[0].tempoMedioSincronizacao
                  : 0,
              ];

              this.dadosResult.tempoMedio = arr;
            }
          }

          if (this.estiloGrafico == 3) {
            if (this.tipoGrafico == 'Taxa de Conversão') {
              this.dadosResult.taxaConversao.taxa = [res.data[0].taxa];
              this.dadosResult.taxaConversao.total = res.data[0].total;
              this.dadosResult.taxaConversao.convertidas =
                res.data[0].convertidas;
            }
          }

          if (this.estiloGrafico == 4) {
            if (this.tipoGrafico == 'Financeiro de Vendas') {
              analyticsData.salesBar2.chartOptions.xaxis.categories = [
                'Mensal',
                'Unicos (Adesão / Rastreador)',
              ];
              analyticsData.salesBar2.series[0].data = [
                res.data[0].valorMensal,
                res.data[0].valorUnico,
              ];
              this.options = null;
              this.series = null;
              this.options = analyticsData.salesBar2.chartOptions;
              this.series = analyticsData.salesBar2.series;
              analyticsData.salesBar2.chartOptions.chart.toolbar.tools.customIcons =
                [
                  {
                    icon: '<img style="opacity: 55% !important; margin: 3px 5px" src="https://cdn-icons-png.flaticon.com/512/32/32763.png?w=740&t=st=1678295581~exp=1678296181~hmac=d347c5542ab822b08e3403edde6e36e8b6ec73d6aecca54bdc1188cf98ba9b94" width="16" opacity="55">',
                    index: 0,
                    title: 'Tela Cheia',
                    class: 'custom-icon',
                    click: this.telaCheia,
                  },
                ];
            }

            if (this.tipoGrafico == 'Ticket Médio') {
              analyticsData.salesBar2.chartOptions.xaxis.categories = [
                'Ticket Médio Mensal',
                'Ticket Médio (Adesão / Rastreador)',
              ];
              analyticsData.salesBar2.series[0].data = [
                res.data[0].valorTicketMensal.toFixed(2),
                res.data[0].valorTicketUnico.toFixed(2),
              ];
              this.options = null;
              this.series = null;
              this.options = analyticsData.salesBar2.chartOptions;
              this.series = analyticsData.salesBar2.series;

              analyticsData.salesBar2.chartOptions.chart.toolbar.tools.customIcons =
                [
                  {
                    icon: '<img style="opacity: 55% !important; margin: 3px 5px" src="https://cdn-icons-png.flaticon.com/512/32/32763.png?w=740&t=st=1678295581~exp=1678296181~hmac=d347c5542ab822b08e3403edde6e36e8b6ec73d6aecca54bdc1188cf98ba9b94" width="16" opacity="55">',
                    index: 0,
                    title: 'Tela Cheia',
                    class: 'custom-icon',
                    click: this.telaCheia,
                  },
                ];
            }

            if (this.tipoGrafico == 'Vendas por Produtos') {
              const arrList = [];
              const arrQtd = [];
              res.data.forEach((element) => {
                arrList.push(element.nomeProduto);
                arrQtd.push(element.valorProduto);
              });
              analyticsData.salesBar2.chartOptions.xaxis.categories = arrList;
              this.legenda = arrList;
              analyticsData.salesBar2.series[0].data = arrQtd;

              this.options = null;
              this.series = null;
              this.options = analyticsData.salesBar2.chartOptions;
              this.series = analyticsData.salesBar2.series;
              analyticsData.salesBar2.chartOptions.chart.toolbar.tools.customIcons =
                [
                  {
                    icon: '<img style="opacity: 55% !important; margin: 3px 5px" src="https://cdn-icons-png.flaticon.com/512/32/32763.png?w=740&t=st=1678295581~exp=1678296181~hmac=d347c5542ab822b08e3403edde6e36e8b6ec73d6aecca54bdc1188cf98ba9b94" width="16" opacity="55">',
                    index: 0,
                    title: 'Tela Cheia',
                    class: 'custom-icon',
                    click: this.telaCheia,
                  },
                ];
            }
          }

          this.carregado = true;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possivel carregar os dados do Gráfico',
            color: 'danger',
          });
        });
    },
    permissaoCompletaOuRegional() {
      const permissoes = ability.getPermission().$;

      const carteira = permissoes.filter(
        (item) =>
          item.subject == 'Associados' &&
          ['Leitura Carteira Regional', 'Leitura Carteira Completa'].includes(
            item.action,
          ),
      );
      this.carteiraCompletaOuRegional = carteira.length > 0 ? false : true;
    },
  },
  components: {
    Filtro,
    VueApexCharts,
    StatisticsCardLine,
  },
  mounted() {
    this.permissaoCompletaOuRegional();
  },
};
</script>
